import { defineLocaleCatalog } from '@/shared/i18n'
import { useLocaleMessages } from '@/shared/composables/useI18n'
import { guildAdminEn } from './en.ts'
import { guildAdminRu } from './ru.ts'

export const guildAdminCatalog = defineLocaleCatalog({
  en: guildAdminEn,
  ru: guildAdminRu,
})

export function useGuildAdminMessages() {
  return useLocaleMessages(guildAdminCatalog)
}
